export const customTheme = {
    headings: { fontFamily: "Roboto, sans-serif" },

    colors: {
        brand: [
            "#def6ff",
            "#b3edff",
            "#86e6fe",
            "#5ce3fe",
            "#41e5fe",
            "#35d2e4",
            "#25a8b2",
            "#157b7f",
            "#004c4d",
            "#00181b",
        ],
        custom: [
            "#e1e6ff",
            "#b2b9ff",
            "#808eff",
            "#4f67fe",
            "#2143fd",
            "#0d32e4",
            "#052cb2",
            "#002380",
            "#00104f",
            "#00031f",
        ],
        deepYellow: [
            "#ffffda",
            "#fffead",
            "#fffe7d",
            "#fffd4b",
            "#fffd1a",
            "#e6e400",
            "#b3b100",
            "#807e00",
            "#4d4c00",
            "#1b1900",
        ],
        grey: [
            "#f3f1fb",
            "#dbd8dc",
            "#c0bec1",
            "#a6a4a7",
            "#8c8a8d",
            "#737173",
            "#5a575a",
            "#403e41",
            "#282428",
            "#120a11",
        ],
    },
    primaryColor: "custom",

    primaryShade: { light: 6, dark: 8 },
};

export const colors = {
    brand: [
        "#e1e6ff",
        "#b2b9ff",
        "#808eff",
        "#4f67fe",
        "#2143fd",
        "#0d32e4",
        "#052cb2",
        "#002380",
        "#00104f",
        "#00031f",
    ],
};
